import NativeMessageHandler from "./../../lib/native_message_handler";
import NativeEvaluateHandler from "./../../lib/native_evaluate_handler";

window.NativeMessageHandler = NativeMessageHandler;
window.NativeEvaluateHandler = NativeEvaluateHandler;
